// assets/cart-checkout-guard.js
(function () {
    if (typeof window === "undefined" || typeof document === "undefined") return;
  
    // tags bloqueadas vindas do setting (ex: "brinde, sem-link")
    var blockedTagsRaw = (window.__CART_DISABLED_PRODUCT_TAGS__ || "brinde").toString();
    var blockedTags = blockedTagsRaw
      .split(",")
      .map(function (s) { return s.trim().toLowerCase(); })
      .filter(Boolean);
  
    // Itens do carrinho (drawer e/ou cart page)
    var ITEM_SELECTOR = '[data-line-key][data-product-tags]';
  
    // Seus botões de checkout
    var CHECKOUT_BTN_SELECTORS = [
      'button[name="checkout"].btn.btn--primary',
      'button[name="checkout"].cart-summary__checkout'
    ];
  
    var NOTICE_ID = "checkout-block-notice";
  
    function parseTags(str) {
      return (str || "")
        .split(",")
        .map(function (s) { return s.trim().toLowerCase(); })
        .filter(Boolean);
    }
  
    function intersects(a, b) {
      for (var i = 0; i < a.length; i++) {
        if (b.indexOf(a[i]) !== -1) return true;
      }
      return false;
    }
  
    function getLineItemsFromDOM() {
      var items = Array.prototype.slice.call(document.querySelectorAll(ITEM_SELECTOR));
      return items.map(function (el) {
        return {
          el: el,
          tags: parseTags(el.getAttribute("data-product-tags") || "")
        };
      });
    }
  
    function shouldBlock() {
      if (!blockedTags.length) return false;
  
      var items = getLineItemsFromDOM();
  
      // Regra: SOMENTE 1 LINHA no carrinho
      if (items.length !== 1) return false;
  
      // e essa linha tem alguma tag bloqueada
      return intersects(items[0].tags, blockedTags);
    }
  
    function findCheckoutButtons() {
      var all = [];
      for (var i = 0; i < CHECKOUT_BTN_SELECTORS.length; i++) {
        var found = Array.prototype.slice.call(document.querySelectorAll(CHECKOUT_BTN_SELECTORS[i]));
        for (var j = 0; j < found.length; j++) all.push(found[j]);
      }
      // remove duplicados
      return all.filter(function (el, idx) { return all.indexOf(el) === idx; });
    }
  
    function ensureNotice(anchorBtn) {
      var existing = document.getElementById(NOTICE_ID);
      if (existing) return existing;
  
      var p = document.createElement("p");
      p.id = NOTICE_ID;
      p.setAttribute("role", "alert");
      p.style.marginTop = "10px";
      p.style.fontSize = "14px";
      p.style.opacity = "0.9";
      p.textContent = "Adicione mais um produto ao carrinho para finalizar a compra.";
  
      // tenta colocar perto do botão que foi bloqueado
      var container =
        (anchorBtn && anchorBtn.closest && anchorBtn.closest(".cart-drawer__actions")) ||
        (anchorBtn && anchorBtn.closest && anchorBtn.closest(".cart-summary")) ||
        (anchorBtn && anchorBtn.parentElement) ||
        document.body;
  
      container.appendChild(p);
      return p;
    }
  
    function removeNotice() {
      var el = document.getElementById(NOTICE_ID);
      if (el && el.parentNode) el.parentNode.removeChild(el);
    }
  
    function apply() {
      var block = shouldBlock();
      var btns = findCheckoutButtons();
  
      if (!btns.length) return;
  
      for (var i = 0; i < btns.length; i++) {
        var btn = btns[i];
  btn.disabled = block;
  btn.setAttribute("aria-disabled", block ? "true" : "false");
  btn.classList.toggle("is-checkout-blocked", block);
  
      }
  
      if (block) ensureNotice(btns[0]);
      else removeNotice();
    }
  
    // Impede submit “na marra” (enter/submit) se estiver bloqueado
    document.addEventListener(
      "submit",
      function (e) {
        var form = e.target;
        if (!form) return;
  
        // se o form contém um desses botões de checkout, protege
        var hasCheckoutBtn = false;
        for (var i = 0; i < CHECKOUT_BTN_SELECTORS.length; i++) {
          if (form.querySelector(CHECKOUT_BTN_SELECTORS[i])) {
            hasCheckoutBtn = true;
            break;
          }
        }
        if (!hasCheckoutBtn) return;
  
        if (shouldBlock()) {
          e.preventDefault();
          e.stopPropagation();
          apply();
        }
      },
      true
    );
  
    // Observa mudanças no DOM (cart drawer/ajax updates)
    var mo = new MutationObserver(function () {
      clearTimeout(mo._t);
      mo._t = setTimeout(apply, 60);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", apply);
    } else {
      apply();
    }
  })();
  